/**
 * Map register invoice payment applications into sale receipt line items.
 *
 * @param {object|null|undefined} context
 * @returns {object[]}
 */
export function invoicePaymentReceiptLineItemsFromContext (context) {
  const applications = Array.isArray(context?.applications) ? context.applications : []
  if (!applications.length) return []

  return applications.map((app, idx) => {
    const amountMinor = Number(app.amountMinor ?? app.amount_minor ?? 0)
    const lineTotal = amountMinor / 100
    const invoiceId = app.invoiceId ?? app.invoice_id ?? idx

    return {
      id: `invoice-payment-${invoiceId}`,
      name: app.label || app.number || `Invoice #${invoiceId}`,
      quantity: 1,
      price: lineTotal,
      total: lineTotal,
      subtotal: lineTotal,
      tax_amount: 0,
      discount_amount: 0,
      is_invoice_payment: true,
      invoice_id: invoiceId,
      caption: app.caption || ''
    }
  })
}

export function saleHasInvoicePaymentReceiptItems (sale) {
  return invoicePaymentReceiptLineItemsFromContext(sale?.invoice_payment_context).length > 0
}
